/**
 * @fileoverview GET handler for the "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id/backfill_counts" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillCounts } from "./constants";
import type { AlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillCountsResult } from "./types";
import { isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillCountsResult } from "./validators";

export const getAlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillCounts = reactQueryFetcherAdapter(
  alloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillCounts,
  (
    signal: AbortSignal,
    appGroupId: string,
    bridgeId: string
  ): Promise<AlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillCountsResult> => {
    return fetch(
      `/alloys/partners/shopify/${appGroupId}/bridges/${bridgeId}/backfill_counts`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillCountsResult
);
